if (!window.QuickAdd) {
  window.QuickAdd = (() => {
    const state = {};

    function getOverlay(id) {
      let overlay = document.getElementById('quick-add-overlay-' + id);
      if (overlay && overlay.parentElement !== document.body) {
        document.body.appendChild(overlay);
      }
      return overlay;
    }

    function open(btn) {
      try {
        const idEl = btn.closest('[data-product-id]');
        if (!idEl) return;
        const id = idEl.dataset.productId;
        if (!id) return;

        const overlay = getOverlay(id);
        if (!overlay) return;

        state[id] = state[id] || { qty: 1, selectedOptions: {} };

        const variantsEl = document.getElementById('qa-variants-' + id);
        if (variantsEl) {
          try {
            const variants = JSON.parse(variantsEl.textContent);
            const firstAvailable = variants.find(v => v.available);
            if (firstAvailable) {
              overlay.querySelectorAll('.qa-option-list').forEach((list, optionIdx) => {
                const optionValue = firstAvailable.options[optionIdx];
                const optionBtn = list.querySelector(`[data-value="${optionValue}"]`);
                if (optionBtn) {
                  list.querySelectorAll('.qa-option-btn').forEach(b => {
                    b.classList.remove('is-selected');
                    b.setAttribute('aria-checked', 'false');
                  });
                  optionBtn.classList.add('is-selected');
                  optionBtn.setAttribute('aria-checked', 'true');
                }
              });
            }
          } catch (e) {}
        }

        overlay.setAttribute('aria-hidden', 'false');
        overlay.classList.add('is-open');
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            const sheet = overlay.querySelector('.qa-sheet');
            if (sheet) sheet.style.transform = 'translateY(0)';
          });
        });
        document.body.classList.add('qa-no-scroll');
        updateVariant(id);
      } catch (err) {
        console.error('QuickAdd.open() error:', err);
      }
    }

    function close(id) {
      try {
        const overlay = getOverlay(id);
        if (!overlay) return;
        const sheet = overlay.querySelector('.qa-sheet');
        if (sheet) sheet.style.transform = 'translateY(100%)';
        setTimeout(() => {
          overlay.classList.remove('is-open');
          overlay.setAttribute('aria-hidden', 'true');
        }, 30);
        document.body.classList.remove('qa-no-scroll');
      } catch (err) {
        console.error('QuickAdd.close() error:', err);
      }
    }

    function adjustQty(btn, delta, id) {
      if (!state[id]) state[id] = { qty: 1, selectedOptions: {} };
      state[id].qty = Math.max(1, (state[id].qty || 1) + delta);
      const el = document.getElementById('qa-qty-' + id);
      if (el) el.textContent = state[id].qty;
    }

    function selectOption(btn, id) {
      try {
        if (btn.classList.contains('is-unavailable')) return;
        const group = btn.closest('.qa-option-list');
        if (!group) return;
        group.querySelectorAll('.qa-option-btn').forEach(b => {
          b.classList.remove('is-selected');
          b.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-checked', 'true');
        updateVariant(id);
      } catch (err) {
        console.error('QuickAdd.selectOption() error:', err);
      }
    }

    function updateVariant(id) {
      const overlay = getOverlay(id);
      const variantsEl = document.getElementById('qa-variants-' + id);
      if (!variantsEl || !overlay) return;
      let variants;
      try {
        variants = JSON.parse(variantsEl.textContent);
      } catch (e) {
        return;
      }

      const selected = [...overlay.querySelectorAll('.qa-option-btn.is-selected')].map(b => b.dataset.value);
      const match = variants.find(v => selected.every((val, i) => v.options[i] === val)) || variants[0];
      if (!match) return;

      overlay.querySelectorAll('[data-variant-id]').forEach(el => {
        el.dataset.variantId = match.id;
      });

      const priceEl = overlay.querySelector('.qa-price');
      const compareEl = overlay.querySelector('.qa-compare-price');
      const badgeEl = overlay.querySelector('.qa-badge');

      if (priceEl) priceEl.textContent = match.price;
      if (compareEl && match.compare_at_price) {
        compareEl.textContent = match.compare_at_price;
        compareEl.style.display = '';
      } else if (compareEl) {
        compareEl.style.display = 'none';
      }
      if (badgeEl) badgeEl.style.display = match.compare_at_price ? '' : 'none';

      const addBtn = overlay.querySelector('.qa-add-btn');
      const buyBtn = overlay.querySelector('.qa-buy-btn');
      if (addBtn) {
        addBtn.disabled = !match.available;
        if (match.available) {
          addBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>Add to cart`;
        } else {
          addBtn.textContent = 'Sold out';
        }
      }
      if (buyBtn) buyBtn.disabled = !match.available;

      overlay.querySelectorAll('.qa-option-list').forEach((list, optionIdx) => {
        list.querySelectorAll('.qa-option-btn').forEach(optionBtn => {
          const optionValue = optionBtn.dataset.value;
          const hasAvailableVariant = variants.some(v => {
            for (let i = 0; i < optionIdx; i++) {
              if (v.options[i] !== selected[i]) return false;
            }
            if (v.options[optionIdx] !== optionValue) return false;
            return v.available;
          });
          optionBtn.classList.toggle('is-unavailable', !hasAvailableVariant);
        });
      });
    }

    async function addToCart(btn, id) {
      const overlay = getOverlay(id);
      const variantId = btn.dataset.variantId;
      const qty = state[id]?.qty || 1;
      btn.classList.add('is-loading');

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: qty,
            sections: ['cart-icon-bubble', 'cart-drawer'],
            sections_url: window.location.pathname
          })
        });

        if (!res.ok) throw new Error('Cart add failed');

        const parsedState = await res.json();

        if (parsedState.sections && parsedState.sections['cart-icon-bubble']) {
          const cartBubble = document.getElementById('cart-icon-bubble');
          if (cartBubble) {
            const tempHtml = new DOMParser().parseFromString(parsedState.sections['cart-icon-bubble'], 'text/html');
            const newBubble = tempHtml.querySelector('[id="cart-icon-bubble"]');
            if (newBubble) cartBubble.replaceWith(newBubble);
          }
        }

        if (parsedState.sections && parsedState.sections['cart-drawer']) {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.classList.toggle('is-empty', parsedState.item_count === 0);
            cartDrawer.renderContents(parsedState);
          }
        }

        btn.classList.remove('is-loading');
        btn.classList.add('is-success');
        btn.innerHTML = '✓ Added';

        setTimeout(() => {
          btn.classList.remove('is-success');
          btn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>Add to cart`;
          close(id);
        }, 0);

        if (window.PUB_SUB_EVENTS && window.publish) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'quick-add',
            productVariantId: variantId,
            cartData: parsedState
          });
        }

        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { source: 'quick-add', variantId, quantity: qty, response: parsedState }
        }));
        document.dispatchEvent(new CustomEvent('cart-item-added', {
          detail: { source: 'quick-add', variantId, quantity: qty }
        }));
      } catch (e) {
        console.error('QuickAdd.addToCart() error:', e);
        btn.classList.remove('is-loading');
        btn.textContent = 'Error – try again';
      }
    }

    function buyNow(btn, id) {
      try {
        if (btn.disabled) return;
        const variantId = btn.dataset.variantId;
        const qty = state[id]?.qty || 1;
        window.location.href = `/cart/${variantId}:${qty}`;
      } catch (err) {
        console.error('QuickAdd.buyNow() error:', err);
      }
    }

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        document.querySelectorAll('.qa-overlay.is-open').forEach(overlay => {
          close(overlay.id.replace('quick-add-overlay-', ''));
        });
      }
    });

    document.addEventListener(
      'click',
      event => {
        const link = event.target.closest('.card-wrapper.product-card-wrapper .card__heading .full-unstyled-link');
        if (!link) return;

        const card = link.closest('.card-wrapper.product-card-wrapper');
        if (!card) return;

        const trigger = card.querySelector('.quick-add-trigger[data-product-id]');
        if (!trigger) return;

        const rect = trigger.getBoundingClientRect();
        const clickedQuickAddArea = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
        if (!clickedQuickAddArea) return;

        event.preventDefault();
        event.stopPropagation();
        window.QuickAdd.open(trigger);
      },
      true
    );

    return { open, close, adjustQty, selectOption, addToCart, buyNow };
  })();
}
